module.exports = __webpack_public_path__ + "static/consultation-ff1914f1303d9ab247bd3ef8fe17579e.svg";